export const getLeftMenuData = [
  {
    title: "Admin",
    key: "admin",
    icon: "icmn icmn-equalizer2",
    children: [
      {
        key: "businessUnits",
        title: "Unidades de Negocio",
        url: "/admin/business-units"
      },
      {
        key: "costCenters",
        title: "Centros de Costo",
        url: "/admin/cost-centers"
      },
      {
        key: "costCenterTypes",
        title: "Productos",
        url: "/admin/products"
      },
      {
        key: "users",
        title: "Usuarios",
        url: "/admin/users"
      }
      /*,
      {
        key: "loginBeta",
        title: "Login Beta",
        url: "/pages/login-beta",
        pro: true
      }*/
    ]
  },
  {
    divider: true
  },
  {
    title: "Clientes",
    key: "customers",
    url: "/customers",
    icon: "icmn icmn-users"
  },
  {
    title: "Suscripciones",
    key: "subscriptions",
    url: "/subscriptions",
    icon: "icmn icmn-price-tags"
  },
  {
    title: "Links de Pago",
    key: "payment-links",
    url: "/payment-links",
    icon: "icmn icmn-link"
  },
  {
    title: "Transacciones",
    key: "transactions",
    url: "/transactions",
    icon: "icmn icmn-list"
  } /*,
  {
    title: "Dashboard Alpha",
    key: "dashboardAlpha",
    url: "/dashboard/alpha",
    icon: "icmn icmn-home"
  }*/
];
export const getTopMenuData = [
  {
    title: "Dashboard Alpha",
    key: "dashboardAlpha",
    url: "/dashboard/alpha",
    icon: "icmn icmn-home"
  },
  {
    title: "AntDesign",
    key: "antComponents",
    icon: "icmn icmn-menu",
    url: "/antd"
  },
  {
    title: "Admin",
    key: "admin",
    icon: "icmn icmn-tree",
    children: [
      {
        key: "businessUnits",
        title: "Unidades de Negocio",
        url: "/admin/business-units"
      },
      {
        key: "costCenters",
        title: "Centros de Costo",
        url: "/admin/cost-centers"
      },
      {
        key: "costCenterTypes",
        title: "Actividades",
        url: "/admin/products"
      },
      {
        key: "users",
        title: "Usuarios",
        url: "/admin/users"
      }
      /*,
      {
        key: "loginBeta",
        title: "Login Beta",
        url: "/pages/login-beta",
        pro: true
      }*/
    ]
  },
  {
    title: "Clientes",
    key: "customers",
    url: "/customers",
    icon: "icmn icmn-users"
  },
  {
    title: "Suscripciones",
    key: "subscriptions",
    url: "/subscriptions",
    icon: "icmn icmn-price-tags"
  },
  {
    title: "Transacciones",
    key: "transactions",
    url: "/transactions",
    icon: "icmn icmn-list2"
  }
];
